import { render, staticRenderFns } from "./BbppProductServicesCC.vue?vue&type=template&id=ec0e3876"
import script from "./BbppProductServicesCC.vue?vue&type=script&lang=js"
export * from "./BbppProductServicesCC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports